module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Sally4Ever-S1.b837adf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Sally4Ever-S1.jpg
// module id = gc2M
// module chunks = 0